import { configureStore } from "@reduxjs/toolkit";
import modalsReducer from "./widget/ModalsReducer";
import homeReducer from "./home/HomeReducer";
import branchListReducer from "./branch/BranchListReducer";
import settingsChangeDefaultBranchReducer from "./settings/SettingsChangeDefaultBranchReducer";
import CountryCodeReducer from "./country_code/CountryCodeReducer";
import CountdownReducer from "./widget/CountdownReducer";
import CountyStateCityAreaReducer from "./country_state_city_area/CountyStateCityAreaReducer";
import GeoReducer from "./country_state_city_area/GeoReducer";
import DetailConnectDeptTeamReducer from "./widget/DetailConnectDeptTeamReducer";
import HomeGuestUserReducer from "./home_guest_user/HomeGuestUserReducer";
import DatePickerAlert from "./widget/DatePickerAlert";
import ChatsReducer from "./chats/ChatsReducer";
import ImageEditorReducer from "./service/ImageEditorReducer";
import DetailConnectGroupReducer from "./widget/DetailConnectGroupReducer";
import FileDocumentPickerReducer from "./service/FileDocumentPickerReducer";
import ARFReducer from "./chats/ARFReducer";
import DivisionsReducer from "./divisions/DivisionsReducer";
import GlobalReducer from "./global/GlobalReducer";

export const store = configureStore({
  reducer: {
    global: GlobalReducer,
    modals: modalsReducer,
    home: homeReducer,
    homeGuestUser: HomeGuestUserReducer,
    branchList: branchListReducer,
    settingsChangeDefaultBranch: settingsChangeDefaultBranchReducer,
    countryCode: CountryCodeReducer,
    countdown: CountdownReducer,
    countryStateCityArea: CountyStateCityAreaReducer,
    geoAlert: GeoReducer,
    detailConnectDeptChat: DetailConnectDeptTeamReducer,
    datePickerAlert: DatePickerAlert,
    chats: ChatsReducer,
    imageEditor: ImageEditorReducer,
    detailConnectGroup: DetailConnectGroupReducer,
    fileDocumentPicker: FileDocumentPickerReducer,
    ARF: ARFReducer,
    divisions: DivisionsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
